"use strict";
exports.__esModule = true;
exports.useInitializeContext = exports.useCarouselContext = exports.CarouselContext = void 0;
var react_1 = require("react");
exports.CarouselContext = react_1.createContext(undefined);
var useCarouselContext = function () {
    var context = react_1.useContext(exports.CarouselContext);
    if (!context) {
        throw new Error('useCarouselContext must be inside a Carousel');
    }
    return context;
};
exports.useCarouselContext = useCarouselContext;
var useInitializeContext = function (_a) {
    var index = _a.index, loopeable = _a.loopeable, nbVisibleItems = _a.nbVisibleItems, onChange = _a.onChange;
    var _b = react_1.useState(index), indexState = _b[0], setIndexState = _b[1];
    var _c = react_1.useState(false), reversingState = _c[0], setReversingState = _c[1];
    var _d = react_1.useState(0), lengthState = _d[0], setLengthState = _d[1];
    var hasNext = loopeable || indexState < lengthState - nbVisibleItems;
    var hasPrevious = loopeable || indexState > 0;
    react_1.useEffect(function () {
        setIndexState(index);
    }, [index]);
    var goTo = function (value) {
        var newIndex = (value + lengthState) % lengthState;
        setIndexState(newIndex);
        setReversingState(value < indexState);
        if (onChange) {
            onChange(newIndex);
        }
    };
    var next = function () {
        if (hasNext) {
            goTo(indexState + 1);
        }
    };
    var previous = function () {
        /* istanbul ignore next */
        if (hasPrevious) {
            goTo(indexState - 1);
        }
    };
    return {
        index: indexState,
        length: lengthState,
        setLength: setLengthState,
        isReversing: reversingState,
        loopeable: loopeable,
        goTo: goTo,
        hasNext: hasNext,
        next: next,
        hasPrevious: hasPrevious,
        previous: previous,
        nbVisibleItems: nbVisibleItems
    };
};
exports.useInitializeContext = useInitializeContext;
//# sourceMappingURL=CarouselContext.js.map